{
  "version": 1,
  "asset_id": "3b7df544-efe6-4f50-b69f-3f5d8b543f12",
  "project_id": "7580f3ab-e7a4-418d-abe6-5eb616986e51",
  "url": "/__l5e/assets-v1/3b7df544-efe6-4f50-b69f-3f5d8b543f12/white-metal-roof-crystal-river-fl-1024.webp",
  "r2_key": "a/v1/7580f3ab-e7a4-418d-abe6-5eb616986e51/3b7df544-efe6-4f50-b69f-3f5d8b543f12/white-metal-roof-crystal-river-fl-1024.webp",
  "original_filename": "white-metal-roof-crystal-river-fl-1024.webp",
  "size": 55190,
  "content_type": "image/webp",
  "created_at": "2026-07-16T15:36:40Z"
}
